import React, { useState } from 'react';
import './ResourceOrchestration.css';
import TaskTable from '../../components/TaskTable/TaskTable';

const initialTasks = [
  { id: 1, loadId: 'LD-10235', deliveryInfo: 'Delivery in: 3 hours', type: 'Tracking Update', margin: 'Low', priority: 'High', assigned: 'Sarah Chen', resourceType: 'Human', eta: '30 min', status: 'Escalated', completed: false, highlighted: false },
  { id: 2, loadId: 'LD-10236', deliveryInfo: 'Delivery in: 4 hours', type: 'Issue Resolution', margin: 'Low', priority: 'High', assigned: 'AI Email Follow Up Template', resourceType: 'AI', eta: '1 hour', status: 'In Progress', completed: false, highlighted: false },
  { id: 3, loadId: 'LD-10234', deliveryInfo: 'Delivery in: 12 hours', type: 'Call Carrier', margin: 'Medium', priority: 'Medium', assigned: 'AI Email Follow Up Template', resourceType: 'AI', eta: '2 hours', status: 'In Progress', completed: false, highlighted: false },
  { id: 4, loadId: 'LD-10238', deliveryInfo: 'Delivery in: 18 hours', type: 'Call Carrier', margin: 'Medium', priority: 'Medium', assigned: 'MacroPoint', resourceType: 'Digital', eta: '5 hours', status: 'Pending', completed: false, highlighted: false },
  { id: 5, loadId: 'LD-10237', deliveryInfo: 'Delivery in: 2 days', type: 'Tracking Update', margin: 'High', priority: 'Low', assigned: 'FourKites', resourceType: 'Digital', eta: '30 min', status: 'Pending', completed: false, highlighted: false },
  { id: 6, loadId: 'LD-10239', deliveryInfo: 'Delivery in: 5 days', type: 'Documentation', margin: 'High', priority: 'Low', assigned: 'AI Email Follow Up Template', resourceType: 'AI', eta: '20 min', status: 'In Progress', completed: false, highlighted: false },
];

const ResourceOrchestration = () => {
  const [tasks, setTasks] = useState(initialTasks);

  const handleAssign = (taskId, newResource) => {
    setTasks(tasks.map(task =>
      task.id === taskId ? { ...task, assigned: newResource } : task
    ));
  };

  const handleComplete = (taskId) => {
    setTasks(tasks.map(task =>
      task.id === taskId ? { ...task, completed: true } : task
    ));
    setTimeout(() => {
      setTasks(tasks.filter(task => task.id !== taskId));
    }, 500); // Corresponds to animation duration
  };

  const simulateUrgentFail = () => {
    const taskToEscalate = tasks.find(t => t.id === 5);
    if (!taskToEscalate) return;

    const updatedTask = {
      ...taskToEscalate,
      priority: 'High',
      assigned: 'Sarah Chen',
      resourceType: 'Human',
      eta: 'Immediate',
      status: 'Escalated',
      highlighted: true
    };

    const otherTasks = tasks.filter(t => t.id !== 5);
    const newTasks = [updatedTask, ...otherTasks].map(t => ({ ...t, highlighted: t.id === 5 }));

    setTasks(newTasks);
  };

  const simulateTaskUpdate = () => {
    const highPriorityTask = tasks.find(t => t.priority === 'High');
    if (!highPriorityTask) return;

    const updatedTask = {
      ...highPriorityTask,
      priority: 'Medium',
      deliveryInfo: 'Delivery in: 2 days',
      highlighted: true,
    };

    const otherTasks = tasks.filter(t => t.id !== highPriorityTask.id);
    const newIndex = Math.min(otherTasks.length, tasks.indexOf(highPriorityTask) + 4);
    
    const newTasks = [
      ...otherTasks.slice(0, newIndex),
      updatedTask,
      ...otherTasks.slice(newIndex)
    ].map((t, index) => ({ ...t, id: index + 1, highlighted: t.id === highPriorityTask.id }));

    setTasks(newTasks);
  };

  return (
    <div className="resource-orchestration-page">
      <div className="page-header">
        <h1>Task Visualization & Assignment</h1>
        <p>Real-time task monitoring and resource allocation</p>
      </div>
      <div className="scenario-buttons">
        <button onClick={simulateUrgentFail}>Simulate Urgent Tracking Fail</button>
        <button onClick={simulateTaskUpdate}>Simulate Task Update</button>
      </div>
      <TaskTable tasks={tasks} onAssign={handleAssign} onComplete={handleComplete} />
    </div>
  );
};

export default ResourceOrchestration;